"use strict";
/**
 * @module Services.TopicAdd
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var TopicSpecificationSerialiser = require("./../../topics/details/topic-specification-serialiser");
/**
 * Serialiser for {@link TopicAddRequest}
 */
var TopicAddRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicAddRequestSerialiserClass, _super);
    function TopicAddRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TopicAddRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TopicAddRequest} to be written
     */
    TopicAddRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        TopicSpecificationSerialiser.write(bos, value.specification);
    };
    return TopicAddRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicAddRequestSerialiserClass = TopicAddRequestSerialiserClass;
/**
 * The {@link TopicAddRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicAddRequestSerialiser = new TopicAddRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-add/topic-add-request-serialiser.js
// module id = 1649
// module chunks = 1